import { defineMessages } from 'react-intl';

export default defineMessages({
  discountMessage: {
    id: 'app.cart.components.cartPrice.discountMessage',
    defaultMessage: 'Descuento por {notes}',
  },
  subtotal: {
    id: 'app.cart.components.cartPrice.subtotal',
    defaultMessage: 'Subtotal',
  },
});
